'use client';
import React, { HTMLAttributes, FC } from 'react';
import { Disclosure } from '@headlessui/react';
import cn from 'classnames';


type AccordionProps = {
  children: (props: { open: boolean }) => React.ReactElement;
};


type AccordionButton = {
  children?: React.ReactNode;
  className?: string;
  open?: boolean;
};

type AccordionContentProps = {
  children?: React.ReactNode;
} & HTMLAttributes<HTMLDivElement>;

const Accordion: FC<AccordionProps> & {
  Button: FC<AccordionButton>;
  Content: FC<AccordionContentProps>;
} = ({ children }) => {
  return (
    <Disclosure>
      {({ open }) => children({ open })}
    </Disclosure>
  );
};

Accordion.Button = ({ children, className, open }: AccordionButton) => {
  return (
    <Disclosure.Button
      className={cn(
        'w-full text-left p-4 align-middle border border-surface-200',
        {
          'bg-surface-200 rounded-t-lg': open,
          'rounded bg-surface-0': !open,
        },
        className
      )}
    >
      {children}
    </Disclosure.Button>
  );
};

Accordion.Content = ({ children, className, ...props }: AccordionContentProps) => {
  return (
    <Disclosure.Panel
      className={cn(
        'w-full p-4 border border-surface-200 rounded-b-lg bg-surface-0',
        className
      )}
      {...props}
    >
      {children}
    </Disclosure.Panel>
  );
};

export default Accordion;